import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { OrganizationConfig } from "@idw-types/data/organization-config";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithBody } from "@utils/http-util";

export const configureCorporateLoginRequest = async (
    organizationId: string,
    relyingPartyId?: string,
    loginServiceId?: string
): Promise<GenericNetworkResponse<OrganizationConfig>> => {
    const route = apiRoutes.serviceConfiguration.organization.login.preference;
    const body = {
        organizationID: organizationId,
        relyingPartyID: relyingPartyId,
        loginServiceID: loginServiceId
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};